import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Observable, of, concat, Subject, Subscription } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  map,
  switchMap,
  tap,
} from 'rxjs/operators';
import Swal from 'sweetalert2';

import { RfqService } from '@app/core/quotes';
import { ExportRfqService } from '@app/shared/services/export-rfq.service';

@Component({
  selector: 'cnc-sku-duplicate-report',
  templateUrl: './sku-duplicate-report.component.html',
  styleUrls: ['./sku-duplicate-report.component.scss'],
})
export class SkuDuplicateReportComponent implements OnInit {
  loading :boolean;
  skuRecord :any;

  constructor(
    public activeModal :NgbActiveModal,
    public rfqSvc :RfqService,
    private cd :ChangeDetectorRef,
    public exportRfq :ExportRfqService,
  ) {}

  ngOnInit() {
    this.getDuplicateSku();
  }

  // ngOnDestroy() {
  //     this.subscription.unsubscribe();
  // }

  getDuplicateSku() {
    this.loading = true;
    this.rfqSvc.getDuplicateSku().subscribe((resp) => {
      this.skuRecord = resp;
      this.skuRecord.forEach((row) => {
        row.is_show = false;
      });
      this.loading = false;
      this.cd.detectChanges();
    });
  }

  download() {
    this.exportRfq.exportDuplicateSKU(this.skuRecord);
  }
}
